/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// import { batchActions } from "redux-batched-actions";
// actions
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { editReport, getClientReportsData } from 'state/actions/reportsState/reports_status';
import { saveReport, updateReport, runReport, downloadReport, saveAndRunReport, discardReportChanges } from 'state/actions/reportsState/selected_report_status';
import { sendErrorMessage } from 'utils/messages';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import ReportControls from 'pages/dashboard/reports/reportcontrols/reportcontrols';



/* ========== ~~~~~~~~~~ CONTROLS FOOTER CHILD ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ appStatus, reportsState, sessionStatus }) => ({
    currentPage: appStatus.currentPage,
    userFirstName: sessionStatus.userFirstName,
    accountUUID: sessionStatus.accountUUID,
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    selectedReportData: reportsState.selectedReportStatus.selectedReportData,
    saveReportPending: reportsState.selectedReportStatus.status.saveReportPending,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
    reportDownloading: reportsState.selectedReportStatus.reportDownloading,
    reportRunning: reportsState.selectedReportStatus.status.runReportPending,
    reportChangeDetected: reportsState.selectedReportStatus.status.reportChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    editReport: reportUUID => dispatch(editReport(reportUUID)),
    saveReport: (reportData, successRoute) => dispatch(saveReport(reportData, successRoute)),
    updateReport: (reportUUID, reportData, successRoute) => dispatch(updateReport(reportUUID, reportData, successRoute)),
    runReport: (reportData, successRoute) => dispatch(runReport(reportData, successRoute)),
    getClientReportsData: accountUUID => dispatch(getClientReportsData(accountUUID)),
    sendErrorMessage: text => dispatch(sendErrorMessage(text)),
    downloadReport: (data, reportType) => dispatch(downloadReport(data, reportType)),
    saveAndRunReport: (reportData, reportUUID, accountUUID) => dispatch(saveAndRunReport(reportData, reportUUID, accountUUID)),
    discardReportChanges: () => dispatch(discardReportChanges())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportControls);
